export * from "./db";
import { zoneList, type ZoneInfo } from "./db";
import { zoneAbbrs, zonesForAbbr } from "./aliases";

export function searchZones(query: string, limit = 40): ZoneInfo[] {
  const q = query.trim().toLowerCase();
  if (!q) return zoneList.slice(0, limit);
  const terms = q.split(/\s+/);
  const abbrMatches = zonesForAbbr(q);
  const scored: [number, ZoneInfo][] = [];
  for (const z of zoneList) {
    const abbrs = zoneAbbrs.get(z.id) ?? [];
    const hay = z.search + " | " + abbrs.join(" ").toLowerCase();
    if (!terms.every((t) => hay.includes(t))) continue;
    let score = 0;
    const city = z.city.toLowerCase();
    const abbrRank = abbrMatches.indexOf(z.id);
    if (abbrRank === 0) score += 200;
    else if (abbrRank > 0) score += 80;
    if (city === q) score += 100;
    else if (city.startsWith(q)) score += 50;
    else if (z.id.toLowerCase().includes(q)) score += 20;
    scored.push([score, z]);
  }
  scored.sort((a, b) => b[0] - a[0] || a[1].id.localeCompare(b[1].id));
  return scored.slice(0, limit).map((s) => s[1]);
}

